/* Dr. King's parity pass 2 (2026-09-18, scroll fix 2026-10-05): 8 Essentials pinned showcase and accordion, matching drkings.com/essentials.
   2026-10-05: directional snap. 2026-10-06: GSAP pinning replaced by position:sticky (jitter) and snap removed. */
(function(){
  if(!/^\/pages\/essentials\/?$/.test(window.location.pathname))return;

  var script=document.currentScript||[].slice.call(document.scripts).find(function(s){return s.src.indexOf('/kb-parity-pass2.js')>-1});
  var assetBase=script?script.src.replace(/kb-parity-pass2\.js.*$/,''):'';
  var names=['Human-Spirit','Nutrition','Water','Fitness','Sleep-1','Nature','Relationships','Hands-On-Techniques'];
  var images=names.map(function(n){return assetBase+'kb-page-'+n+'.webp'});

  function load(src){
    return new Promise(function(resolve,reject){
      var s=document.createElement('script');s.src=src;s.async=false;s.onload=resolve;s.onerror=reject;document.head.appendChild(s);
    });
  }

  function initAccordion(){
    var items=[].slice.call(document.querySelectorAll('.kb-source-page details.et_pb_accordion_item'));
    items.forEach(function(item,i){
      if(i===0)item.open=true;
      item.addEventListener('toggle',function(){
        if(!item.open)return;
        items.forEach(function(other){if(other!==item&&other.open)other.open=false});
      });
    });
  }

  function initShowcase(){
    var section=document.querySelector('.dk-eight-section');
    var image=document.querySelector('.dk-eight-image img');
    var items=document.querySelectorAll('.dk-eight-item');
    if(!section||!image||!items.length||!window.gsap)return;
    images.forEach(function(src){var i=new Image();i.src=src});
    var current=0;
    [].forEach.call(items,function(item){item.classList.remove('active')});
    items[0].classList.add('active');
    image.removeAttribute('srcset');image.removeAttribute('sizes');image.removeAttribute('loading');
    image.src=images[0];
    document.body.classList.add('kb-eight-ready');

    function changeSlide(index){
      if(index===current)return;
      current=index;
      [].forEach.call(items,function(item){item.classList.remove('active')});
      if(items[index])items[index].classList.add('active');
      gsap.to(image,{opacity:.85,duration:.15,ease:'power1.out',onComplete:function(){
        image.src=images[index];
        gsap.to(image,{opacity:1,duration:.25,ease:'power1.out'});
      }});
    }

    /* 2026-10-06: native sticky instead of GSAP pinning. Pinning by transform inside Horizon's .page-wrapper scroller
       repositioned the section every frame and jittered; position:sticky lets the browser hold it still. The slide
       index follows scroll progress through a tall stage; no snap, so small wheel ticks never get pulled back. */
    if(!(window.CSS&&CSS.supports&&CSS.supports('overflow','clip'))){document.body.classList.remove('kb-eight-ready');return}
    var stage=document.createElement('div');stage.className='dk-eight-stage';
    section.parentNode.insertBefore(stage,section);stage.appendChild(section);
    document.body.classList.add('kb-eight-sticky');
    var scroller=null,travel=0,stageTop=0,ticking=false;
    function scrollPos(){return scroller===window?(window.scrollY||document.documentElement.scrollTop):scroller.scrollTop}
    function measure(){
      var wrapper=document.querySelector('.page-wrapper');
      scroller=(wrapper&&/(auto|scroll)/.test(getComputedStyle(wrapper).overflowY))?wrapper:window;
      travel=window.innerWidth<768?4000:5000;
      stage.style.height=(window.innerHeight+travel)+'px';
      var r=stage.getBoundingClientRect();
      stageTop=r.top+scrollPos()-(scroller===window?0:scroller.getBoundingClientRect().top);
      update();
    }
    function update(){
      ticking=false;
      var p=(scrollPos()-stageTop)/travel;
      if(p<0)p=0;if(p>1)p=1;
      changeSlide(Math.round(p*(items.length-1)));
    }
    function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update)}}
    function bind(){
      window.removeEventListener('scroll',onScroll);
      [].forEach.call(document.querySelectorAll('.page-wrapper'),function(w){w.removeEventListener('scroll',onScroll)});
      measure();
      (scroller===window?window:scroller).addEventListener('scroll',onScroll,{passive:true});
    }
    bind();
    var desktop=window.matchMedia('(min-width: 990px)');
    if(desktop.addEventListener)desktop.addEventListener('change',bind);
    window.addEventListener('resize',function(){measure()});
    window.addEventListener('load',function(){measure()});
  }

  function start(){
    initAccordion();
    load('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js')
      .then(initShowcase)
      .catch(function(){});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

/* Practitioner Portal: link to the Professional's Website (pass 2, 2026-09-18) */
(function(){
if(!/^\/pages\/professionals\/?$/.test(window.location.pathname))return;
function addButton(){
var band=document.querySelector('.kb-practitioner-page__band');
if(!band||band.querySelector('.kb-pro-button'))return;
var p=document.createElement('p');
var a=document.createElement('a');
a.className='kb-pro-button';a.href='https://www.safe-care.com/my-account/';a.target='_blank';a.rel='noopener';a.textContent='Visit the Professional Website';
p.appendChild(a);
var first=band.querySelector('p');
if(first&&first.nextSibling)band.insertBefore(p,first.nextSibling);else band.appendChild(p);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',addButton);else addButton();
})();
